<template>
  <VBanner class="border-0 py-3 px-0 flex-none">
    <div class="max-w-7xl mx-auto w-full px-3 lg:px-8">
      <div
        class="flex justify-between items-start md:items-center text-base gap-2 max-sm:gap-3 flex-col sm:flex-row flex-wrap md:!flex-nowrap"
      >
        <slot name="text" />
        <div class="flex items-center gap-3 flex-wrap sm:!flex-nowrap">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </VBanner>
</template>
